<!--
Renders a single performance moment for anything *other* than end of year, which has special affordances for
creating reviews for connections and doing preparation conversations
-->
<template>
    <div class="max-w-4xl mx-auto w-full px-4">
        <div class="my-10">
            <BasePageTitle :title="moment.title" :subtitle="moment.subtitle" subtitle-multiline />
        </div>

        <!-- CTA Cards -->
        <div v-if="ctas.length > 0" class="flex flex-col gap-3">
            <MomentsCard
                v-for="cta in ctas"
                :id="cta.id"
                :key="cta.id"
                :label="cta.label"
                :start-date="cta.start_date"
                :due-date="cta.due_date"
                :prompt-call-code="cta.prompt_call_code"
                :existing-convo-url="cta.existing_convo_url"
                :manager-enabled="cta.manager_enabled"
                :ic-enabled="cta.ic_enabled"
                :is-completed="cta.is_completed"
                :is-locked="cta.is_locked && !cta.is_completed"
                :track="{
                    moment_id: moment.id,
                    moment_title: moment.title,
                    moment_subtitle: moment.subtitle,
                    moment_start_date: moment.start_date,
                    moment_expiration_date: moment.expiration_date,
                    moment_state: moment.state,
                }" />
        </div>
    </div>
</template>

<script setup>
import BasePageTitle from "~vue/components/BasePageTitle.vue";
import MomentsCard from "~vue/components/moments/MomentsCard.vue";
import { computed } from "vue";

const { moment } = defineProps({
    moment: {
        type: Object,
        required: true,
    },
});

const ctas = computed(() => {
    return moment.ctas.filter((cta) => !cta.reviewer_target || cta.reviewer_target == "self");
});
</script>
